export default "__VITE_ASSET__BWgJAj2i__"